import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=1f3f0444&scoped=true"
import script from "./ShopDetails.vue?vue&type=script&lang=js"
export * from "./ShopDetails.vue?vue&type=script&lang=js"
import style0 from "./ShopDetails.vue?vue&type=style&index=0&id=1f3f0444&prod&lang=css"
import style1 from "./ShopDetails.vue?vue&type=style&index=1&id=1f3f0444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3f0444",
  null
  
)

export default component.exports